import React from "react";
import TextField from "@components/TextField/TextField";
import styles from "./UserInfoFields.module.css";

interface UserInfoFieldsProps {
  name: string;
  email: string;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onNameChange?: (value: string) => void;
  onEmailChange?: (value: string) => void;
  showErrors?: boolean;
  isAttemptedSubmit?: boolean;
}

export const UserInfoFields: React.FC<UserInfoFieldsProps> = ({
  name,
  email,
  onChange,
  onNameChange,
  onEmailChange,
  showErrors = false,
  isAttemptedSubmit = false,
}) => {
  // Handle change and delegate to the appropriate handler
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name: fieldName, value } = e.target;
    
    // Call the appropriate handler based on field name
    if (fieldName === "name" && onNameChange) {
      onNameChange(value);
    } else if (fieldName === "email" && onEmailChange) {
      onEmailChange(value);
    }
    
    // Also call the legacy onChange handler if provided
    if (onChange) {
      onChange(e);
    }
  };

  // Determine which error condition to check
  const shouldShowErrors = showErrors || isAttemptedSubmit;

  return (
    <div className={styles.fieldsContainer}>
      <TextField
        title="Имя"
        placeholder="Отображается публично"
        name="name"
        value={name}
        onChange={handleChange}
        required
        error={
          shouldShowErrors && name.trim() === ""
            ? "Необходимо заполнить поле 'Имя'"
            : ""
        }
      />
      <TextField
        title="Email"
        placeholder="Не отображается публично"
        name="email"
        type="email"
        value={email}
        onChange={handleChange}
        required
        error={
          shouldShowErrors && email.trim() === ""
            ? "Необходимо заполнить поле 'Email'"
            : ""
        }
      />
    </div>
  );
};
